import { create } from 'zustand';
import type { TakContact } from '@vtak/shared';

interface ContactsState {
  contacts: TakContact[];
  setContacts: (contacts: TakContact[]) => void;
}

/** Store for TAK contact list */
export const useContactsStore = create<ContactsState>((set) => ({
  contacts: [],
  setContacts: (contacts) => set({ contacts }),
}));
